export const styles = {
  section: {
    padding: "60px 20px",
    maxWidth: 900,
    margin: "0 auto",
  },
  title: {
    fontSize: 28,
    fontWeight: 700,
    textAlign: "center",
    marginBottom: 8,
  },
  subtitle: {
    textAlign: "center",
    color: "#94a3b8",
    marginBottom: 32,
    fontSize: 14,
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 24,
    alignItems: "start",
  },
  videoCard: {
    background: "linear-gradient(155deg, rgba(12,18,28,0.92), rgba(20,29,45,0.88))",
    borderRadius: 18,
    padding: 16,
    border: "1px solid rgba(148,163,184,0.22)",
    boxShadow: "0 22px 52px rgba(2,6,23,0.4), inset 0 1px 0 rgba(255,255,255,0.08)",
    backdropFilter: 'blur(8px) saturate(1.06)',
    WebkitBackdropFilter: 'blur(8px) saturate(1.06)',
  },
  hiddenVideo: {
    // Keep a full-size feed so face tracking receives proper frame dimensions,
    // while keeping it completely invisible to the user in production mode.
    position: "fixed",
    width: "100vw",
    height: "100vh",
    opacity: 0,
    pointerEvents: "none",
    objectFit: "cover",
    transform: "scaleX(-1)",
    left: 0,
    top: 0,
    zIndex: -1,
  },
  productionCalibrationOverlay: {
    position: 'fixed',
    inset: 0,
    zIndex: 10001,
    display: 'grid',
    placeItems: 'center',
    pointerEvents: 'auto',
    background: 'radial-gradient(132% 122% at 50% 58%, rgba(2,6,23,0.06), rgba(2,6,23,0.66) 54%, rgba(2,6,23,0.9) 100%), linear-gradient(180deg, rgba(3,8,20,0.32), rgba(2,6,23,0.74))',
    backdropFilter: 'blur(12px) saturate(0.94)',
    WebkitBackdropFilter: 'blur(12px) saturate(0.94)',
  },
  productionCalibrationCenter: {
    position: 'relative',
    width: 'min(92vw, 840px)',
    display: 'grid',
    placeItems: 'center',
    textAlign: 'center',
    padding: '10px',
    boxSizing: 'border-box',
  },
  productionVideoCard: {
    position: 'relative',
    width: '100%',
    height: '100%',
    borderRadius: 20,
    overflow: 'hidden',
    border: '1px solid rgba(255,255,255,0.2)',
    background: 'linear-gradient(145deg, rgba(15,23,42,0.86), rgba(30,41,59,0.66))',
    boxShadow: '0 32px 78px rgba(2,6,23,0.58), inset 0 1px 0 rgba(255,255,255,0.18)',
  },
  productionIntroVideo: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    filter: 'saturate(1.06) contrast(1.02)',
  },
  productionTargetOverlay: {
    position: 'absolute',
    top: 18,
    left: 18,
    width: 126,
    height: 126,
    borderRadius: '50%',
    display: 'grid',
    placeItems: 'center',
    background: 'radial-gradient(circle at 35% 35%, rgba(248,250,252,0.22), rgba(30,41,59,0.35) 55%, rgba(2,6,23,0.2) 80%)',
    border: '1px solid rgba(255,255,255,0.24)',
    boxShadow: '0 20px 44px rgba(2,6,23,0.46), 0 0 0 12px rgba(125,211,252,0.08)',
  },
  productionTargetInner: {
    width: 94,
    height: 94,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 2,
    border: '1px solid rgba(255,255,255,0.4)',
    background: 'linear-gradient(145deg, rgba(15,23,42,0.9), rgba(30,41,59,0.76))',
    boxShadow: '0 12px 26px rgba(2,6,23,0.5)',
  },
  productionTargetE: {
    color: '#E8001C',
    fontWeight: 900,
    fontSize: 28,
    textShadow: '0 0 18px rgba(232,0,28,0.36)',
  },
  productionTargetIE: {
    color: '#f8fafc',
    fontWeight: 700,
    fontSize: 28,
    textShadow: '0 0 18px rgba(248,250,252,0.24)',
  },
  productionUnmuteCTA: {
    position: 'absolute',
    left: '50%',
    bottom: 64,
    transform: 'translateX(-50%)',
    border: '1px solid rgba(125,211,252,0.52)',
    borderRadius: 999,
    padding: '10px 18px',
    background: 'linear-gradient(145deg, rgba(2,132,199,0.52), rgba(14,116,144,0.36))',
    color: '#ecfeff',
    fontWeight: 700,
    cursor: 'pointer',
    boxShadow: '0 10px 24px rgba(8,47,73,0.42)',
    backdropFilter: 'blur(10px) saturate(1.12)',
    WebkitBackdropFilter: 'blur(10px) saturate(1.12)',
    transition: 'transform 180ms ease, box-shadow 220ms ease, filter 220ms ease',
  },
  productionVideoControls: {
    position: 'absolute',
    right: 18,
    bottom: 16,
    display: 'flex',
    gap: 10,
  },
  productionControlPrimary: {
    border: '1px solid rgba(125,211,252,0.62)',
    borderRadius: 999,
    padding: '10px 16px',
    background: 'linear-gradient(145deg, rgba(2,132,199,0.58), rgba(14,116,144,0.42))',
    color: '#e0f2fe',
    fontWeight: 700,
    fontSize: 12,
    letterSpacing: 0.3,
    cursor: 'pointer',
    boxShadow: '0 10px 24px rgba(2,132,199,0.26)',
    transition: 'transform 160ms ease, box-shadow 220ms ease, filter 220ms ease',
  },
  productionControlSecondary: {
    border: '1px solid rgba(255,255,255,0.34)',
    borderRadius: 999,
    padding: '10px 16px',
    background: 'linear-gradient(145deg, rgba(15,23,42,0.8), rgba(30,41,59,0.58))',
    color: '#f8fafc',
    fontWeight: 600,
    fontSize: 12,
    letterSpacing: 0.3,
    cursor: 'pointer',
    boxShadow: '0 10px 20px rgba(2,6,23,0.36)',
    transition: 'transform 160ms ease, box-shadow 220ms ease, filter 220ms ease',
  },
  productionProgressInline: {
    position: 'absolute',
    left: 18,
    bottom: 18,
    borderRadius: 999,
    border: '1px solid rgba(125,211,252,0.45)',
    background: 'rgba(2,6,23,0.58)',
    color: '#7dd3fc',
    fontWeight: 700,
    fontSize: 12,
    padding: '8px 12px',
    letterSpacing: 0.3,
  },
  productionPromptCard: {
    position: 'relative',
    width: 'min(92vw, 580px)',
    padding: '30px 24px',
    borderRadius: 18,
    border: '1px solid rgba(125,211,252,0.4)',
    background: 'linear-gradient(145deg, rgba(15,23,42,0.82), rgba(30,41,59,0.58))',
    boxShadow: '0 28px 64px rgba(2,6,23,0.54), inset 0 1px 0 rgba(255,255,255,0.14)',
    backdropFilter: 'blur(8px) saturate(1.04)',
    WebkitBackdropFilter: 'blur(8px) saturate(1.04)',
    display: 'grid',
    justifyItems: 'center',
    gap: 6,
    boxSizing: 'border-box',
  },
  productionPromptTitle: {
    color: '#e2e8f0',
    fontWeight: 800,
    fontSize: 22,
    letterSpacing: 0.3,
  },
  productionPromptText: {
    color: '#a5b4c7',
    fontSize: 14,
    marginTop: 8,
    marginBottom: 18,
    lineHeight: 1.5,
  },
  productionPromptHint: {
    color: '#94a3b8',
    fontSize: 12,
    marginTop: 12,
    lineHeight: 1.45,
  },
  productionReplayStrip: {
    marginTop: 14,
    width: '100%',
    display: 'grid',
    gap: 10,
    justifyItems: 'center',
    padding: '10px 12px',
    borderRadius: 12,
    border: '1px solid rgba(125,211,252,0.3)',
    background: 'linear-gradient(145deg, rgba(2,132,199,0.16), rgba(14,116,144,0.1))',
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.08)',
  },
  productionReplayText: {
    color: '#cbd5e1',
    fontSize: 12,
    lineHeight: 1.45,
  },
  productionReplayBar: {
    marginTop: 14,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    flexWrap: 'wrap',
    padding: '12px 14px',
    borderRadius: 14,
    border: '1px solid rgba(125,211,252,0.24)',
    background: 'linear-gradient(145deg, rgba(2,132,199,0.12), rgba(15,23,42,0.18))',
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.06)',
  },
  productionReplayMeta: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 2,
    flex: 1,
    minWidth: 220,
  },
  productionReplayKicker: {
    fontSize: 10,
    letterSpacing: 1.2,
    textTransform: 'uppercase',
    fontWeight: 700,
    color: '#7dd3fc',
    opacity: 0.95,
  },
  productionReplayLabel: {
    fontSize: 12,
    lineHeight: 1.4,
    color: '#dbeafe',
    textAlign: 'left',
  },
  productionReplayButton: {
    border: '1px solid rgba(125,211,252,0.52)',
    borderRadius: 999,
    padding: '9px 14px',
    color: '#ecfeff',
    fontWeight: 700,
    fontSize: 12,
    letterSpacing: 0.25,
    cursor: 'pointer',
    boxShadow: '0 8px 20px rgba(2,132,199,0.22)',
    transition: 'transform 160ms ease, box-shadow 220ms ease, filter 220ms ease',
    whiteSpace: 'nowrap',
    alignSelf: 'center',
  },
  productionRipple: {
    position: 'absolute',
    width: 180,
    height: 180,
    borderRadius: '50%',
    border: '1px solid rgba(56,189,248,0.35)',
    animation: 'eieProdRipple 2100ms ease-out infinite',
  },
  productionCore: {
    width: 136,
    height: 136,
    borderRadius: '50%',
    border: '1px solid rgba(255,255,255,0.22)',
    background: 'linear-gradient(145deg, rgba(15,23,42,0.88), rgba(30,41,59,0.76))',
    display: 'grid',
    placeItems: 'center',
    animation: 'eieProdPulse 1500ms ease-in-out infinite',
  },
  productionBrandRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 2,
  },
  productionBrandE: {
    fontSize: 42,
    fontWeight: 900,
    letterSpacing: 1.8,
    color: '#E8001C',
    textShadow: '0 0 22px rgba(232,0,28,0.35)',
  },
  productionBrandIE: {
    fontSize: 42,
    fontWeight: 700,
    letterSpacing: 1.6,
    color: '#f8fafc',
    textShadow: '0 0 24px rgba(248,250,252,0.28)',
  },
  productionTitle: {
    marginTop: 14,
    color: '#e2e8f0',
    fontWeight: 700,
    fontSize: 18,
    letterSpacing: 0.4,
  },
  productionProgress: {
    marginTop: 6,
    color: '#7dd3fc',
    fontWeight: 700,
    fontSize: 16,
  },
  productionHint: {
    marginTop: 8,
    color: '#94a3b8',
    fontSize: 12,
    maxWidth: 340,
    lineHeight: 1.4,
    textAlign: 'center',
  },
  productionPrivacyNotice: {
    marginTop: 14,
    width: '100%',
    padding: '10px 12px',
    borderRadius: 12,
    border: '1px solid rgba(125,211,252,0.36)',
    background: 'linear-gradient(145deg, rgba(15,23,42,0.64), rgba(30,41,59,0.42))',
    color: '#e2e8f0',
    fontSize: 12,
    lineHeight: 1.45,
    fontWeight: 700,
    letterSpacing: 0.15,
    boxShadow: '0 10px 26px rgba(2,6,23,0.32)',
  },
  productionCancelButton: {
    border: '1px solid rgba(255,255,255,0.18)',
    borderRadius: 999,
    padding: '9px 20px',
    background: 'transparent',
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: 0.3,
    cursor: 'pointer',
    opacity: 0.7,
    transition: 'opacity 220ms ease',
  },
  productionExitButton: {
    position: 'fixed',
    left: '50%',
    bottom: 26,
    transform: 'translateX(-50%)',
    zIndex: 10004,
    border: '1px solid rgba(255,255,255,0.22)',
    borderRadius: 999,
    padding: '12px 22px',
    minWidth: 192,
    background: 'linear-gradient(145deg, rgba(15,23,42,0.78), rgba(30,41,59,0.56))',
    color: '#f8fafc',
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 1.3,
    textTransform: 'uppercase',
    cursor: 'pointer',
    backdropFilter: 'blur(12px) saturate(1.05)',
    WebkitBackdropFilter: 'blur(12px) saturate(1.05)',
    boxShadow: '0 16px 40px rgba(2,6,23,0.5), inset 0 1px 0 rgba(255,255,255,0.22)',
    transition: 'transform 180ms ease, box-shadow 220ms ease, border-color 220ms ease, background 220ms ease',
  },
  videoContainer: {
    width: "100%",
    aspectRatio: "4/3",
    background: "#0f0f1a",
    borderRadius: 12,
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  video: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: 12,
    transform: "scaleX(-1)",
  },
  introVideo: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: 12,
    background: '#000',
  },
  calibrationOverlaySmall: {
    position: 'absolute',
    right: 12,
    top: 12,
    width: 120,
    height: 120,
    borderRadius: '50%',
    display: 'grid',
    placeItems: 'center',
    zIndex: 6,
    pointerEvents: 'none',
  },
  localReplayCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10,
    width: '100%',
    boxSizing: 'border-box',
    padding: '12px 12px 10px',
    borderRadius: 12,
    border: '1px solid rgba(125,211,252,0.18)',
    background: 'linear-gradient(145deg, rgba(2,132,199,0.10), rgba(15,23,42,0.22))',
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.05)',
  },
  localReplayRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    alignItems: 'center',
    textAlign: 'center',
    maxWidth: 320,
  },
  localReplayKicker: {
    fontSize: 10,
    letterSpacing: 1.1,
    textTransform: 'uppercase',
    color: '#7dd3fc',
    fontWeight: 700,
  },
  localReplayLabel: {
    color: '#dbeafe',
    fontSize: 12,
    lineHeight: 1.4,
    textAlign: 'center',
  },
  calibrationTargetStandalone: {
    position: 'relative',
    width: 120,
    height: 120,
    marginTop: 12,
    borderRadius: '50%',
    display: 'grid',
    placeItems: 'center',
  },
  localReplayButton: {
    border: '1px solid rgba(125,211,252,0.52)',
    borderRadius: 999,
    padding: '9px 14px',
    background: 'linear-gradient(145deg, rgba(2,132,199,0.48), rgba(14,116,144,0.36))',
    color: '#ecfeff',
    fontWeight: 700,
    fontSize: 12,
    letterSpacing: 0.25,
    cursor: 'pointer',
    boxShadow: '0 8px 20px rgba(2,132,199,0.22)',
    transition: 'transform 160ms ease, box-shadow 220ms ease, filter 220ms ease',
  },
  unmuteCTA: {
    position: 'absolute',
    bottom: 18,
    left: '50%',
    transform: 'translateX(-50%)',
    padding: '10px 18px',
    borderRadius: 999,
    border: '1px solid rgba(125,211,252,0.52)',
    background: 'linear-gradient(145deg, rgba(2,132,199,0.52), rgba(14,116,144,0.36))',
    color: '#ecfeff',
    fontWeight: 700,
    zIndex: 8,
    cursor: 'pointer',
    boxShadow: '0 10px 24px rgba(8,47,73,0.42)',
    transition: 'transform 180ms ease, box-shadow 220ms ease, filter 220ms ease',
  },
  videoControls: {
    position: 'absolute',
    right: 12,
    bottom: 12,
    display: 'flex',
    gap: 8,
    zIndex: 7,
  },
  placeholder: {
    textAlign: "center",
    color: "#64748b",
  },
  controls: {
    marginTop: 12,
    textAlign: "center",
  },
  btnStart: {
    padding: "10px 28px",
    borderRadius: 999,
    border: "1px solid rgba(125,211,252,0.56)",
    background: "linear-gradient(145deg, rgba(2,132,199,0.58), rgba(14,116,144,0.42))",
    color: "#ecfeff",
    fontWeight: 600,
    fontSize: 15,
    cursor: "pointer",
    boxShadow: '0 10px 24px rgba(2,132,199,0.24)',
    transition: 'transform 160ms ease, box-shadow 220ms ease, filter 220ms ease',
  },
  btnStop: {
    padding: "10px 28px",
    borderRadius: 999,
    border: "1px solid rgba(248,113,113,0.48)",
    background: "linear-gradient(145deg, rgba(220,38,38,0.72), rgba(185,28,28,0.62))",
    color: "#fff",
    fontWeight: 600,
    fontSize: 15,
    cursor: "pointer",
    boxShadow: '0 10px 24px rgba(127,29,29,0.34)',
    transition: 'transform 160ms ease, box-shadow 220ms ease, filter 220ms ease',
  },
  btnLog: {
    padding: '8px 12px',
    borderRadius: 8,
    border: '1px solid #0284c7',
    background: '#0c4a6e',
    color: '#e0f2fe',
    fontWeight: 600,
    fontSize: 12,
    cursor: 'pointer',
  },
  btnClear: {
    padding: '8px 12px',
    borderRadius: 8,
    border: '1px solid #475569',
    background: '#1e293b',
    color: '#cbd5e1',
    fontWeight: 600,
    fontSize: 12,
    cursor: 'pointer',
  },
  btnLogDisabled: {
    padding: '8px 12px',
    borderRadius: 8,
    border: '1px solid #334155',
    background: '#111827',
    color: '#64748b',
    fontWeight: 600,
    fontSize: 12,
    cursor: 'not-allowed',
  },
  metaPanel: {
    marginTop: 10,
    padding: '10px 12px',
    borderRadius: 10,
    background: '#0f172a',
    border: '1px solid #1e293b',
  },
  metaGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: 8,
  },
  metaField: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 4,
  },
  metaLabel: {
    fontSize: 11,
    color: '#94a3b8',
    letterSpacing: 0.2,
  },
  metaInput: {
    width: '100%',
    borderRadius: 6,
    border: '1px solid #334155',
    background: '#020617',
    color: '#e2e8f0',
    fontSize: 12,
    padding: '6px 8px',
  },
  metricsCard: {
    background: "linear-gradient(155deg, rgba(12,18,28,0.92), rgba(20,29,45,0.88))",
    borderRadius: 18,
    padding: 24,
    border: "1px solid rgba(148,163,184,0.22)",
    boxShadow: "0 22px 52px rgba(2,6,23,0.4), inset 0 1px 0 rgba(255,255,255,0.08)",
    minHeight: 280,
  },
  error: {
    background: "#7f1d1d",
    color: "#fca5a5",
    padding: "8px 12px",
    borderRadius: 8,
    marginBottom: 12,
    fontSize: 13,
  },
  calibrating: {
    background: "#1e3a5f",
    color: "#93c5fd",
    padding: "12px 16px",
    borderRadius: 8,
    fontSize: 14,
    textAlign: "center",
  },
  emotionRow: {
    display: "flex",
    alignItems: "center",
    gap: 16,
    marginBottom: 24,
  },
  emoji: { fontSize: 48 },
  emotionLabel: {
    fontSize: 22,
    fontWeight: 700,
    textTransform: "capitalize",
  },
  confidence: {
    fontSize: 13,
    color: "#94a3b8",
  },
  metric: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginBottom: 12,
    fontSize: 13,
    color: "#cbd5e1",
  },
  barBg: {
    flex: 1,
    height: 8,
    background: "#334155",
    borderRadius: 4,
    overflow: "hidden",
  },
  barFill: {
    height: "100%",
    borderRadius: 4,
    transition: "width 0.3s ease",
  },
  metricValue: {
    width: 44,
    textAlign: "right",
    fontFamily: "monospace",
    fontSize: 13,
  },
  cognitive: {
    marginTop: 16,
    padding: "8px 12px",
    background: "#1e293b",
    borderRadius: 8,
    fontSize: 14,
    textAlign: "center",
  },
  authenticity: {
    marginTop: 8,
    padding: "8px 12px",
    background: "#1e293b",
    borderRadius: 8,
    fontSize: 14,
    textAlign: "center",
  },
  hint: {
    color: "#64748b",
    textAlign: "center",
    marginTop: 40,
  },
};
